export const SET_FINISHED_APPLICATION_DATA = 'SET_FINISHED_APPLICATION_DATA';
